import useLocalization from '../hooks/useLocalization'

interface HRISServicesProps {
   hasCore: boolean
   className: string
}

export default function HRISServices({
   hasCore,
   className,
}: HRISServicesProps) {
   const host_url =
      process.env.REACT_APP_HOST_URL || 'https://quote.bamboohr.net'
   const { getString } = useLocalization(host_url)

   const HRISSectionHeader = getString(
      'pdf.hrisservices.sectionheader',
      'Additional HRIS Services not included in this price quote:',
   )

   const backgroundChecks = getString(
      'pdf.hrisservices.backgroundchecks',
      'Background Checks',
   )

   const i9AndEVerify = getString(
      'pdf.hrisservices.i9andeverify',
      'I-9 & E-Verify',
   )

   const consultingServices = getString(
      'pdf.hrisservices.consultingservices',
      'Consulting Services',
   )

   const managedPayrollServices = getString(
      'pdf.hrisservices.managedpayrollservices',
      'Managed Payroll Services',
   )

   const linkedInPremiumJobAds = getString(
      'pdf.hrisservices.linkedinpremiumjobads',
      'LinkedIn Premium Job Ads',
   )

   if (hasCore) {
      return (
         <div className={className}>
            <b className='productHeader'>{HRISSectionHeader}</b>
            <br />
            <table
               className='tableClass4 hrisServicesList'
               cellPadding='0'
               cellSpacing='0'
               style={{ marginTop: '1em' }}
            >
               <thead>
                  <tr>
                     <th scope='col'>&nbsp;</th>
                  </tr>
               </thead>
               <tfoot>
                  <tr>
                     <td>&nbsp;</td>
                  </tr>
               </tfoot>
               <tbody>
                  <tr>
                     <td>{backgroundChecks}</td>
                  </tr>
                  <tr>
                     <td>{i9AndEVerify}</td>
                  </tr>
                  <tr>
                     <td>{consultingServices}</td>
                  </tr>
                  <tr>
                     <td>{managedPayrollServices}</td>
                  </tr>
                  <tr>
                     <td>{linkedInPremiumJobAds}</td>
                  </tr>
               </tbody>
            </table>
         </div>
      )
   } else return <></>
}
